// ===== 69黑料 首页 mock 数据（纯静态演示，无真实指向） =====

export type Tone = "primary" | "accent" | "secondary";

export interface StatItem {
  num: string;
  unit: string;
  label: string;
  desc: string;
  tone: Tone;
}

export const stats: StatItem[] = [
  { num: "286", unit: "人", label: "人物档案归档", desc: "争议 / 翻车 / 塌房三类口径", tone: "accent" },
  { num: "31", unit: "条", label: "本周新增线索", desc: "双信源比对后入档", tone: "secondary" },
  { num: "7", unit: "档", label: "主题翻车榜单", desc: "按热度实时重排", tone: "primary" },
  { num: "48", unit: "h", label: "复核时效窗口", desc: "跨平台证据交叉验证", tone: "secondary" },
];

export interface Topic {
  name: string;
  count: number;
  tone?: Tone;
}

export interface TopicGroup {
  id: string;
  label: string;
  desc: string;
  topics: Topic[];
}

export const topicGroups: TopicGroup[] = [
  {
    id: "flame",
    label: "风口浪尖",
    desc: "谁正在被追着打",
    topics: [
      { name: "塌房名单", count: 328, tone: "primary" },
      { name: "翻车主角", count: 217, tone: "accent" },
      { name: "争议主角", count: 163 },
      { name: "新上榜", count: 64, tone: "accent" },
      { name: "持续发酵", count: 88 },
      { name: "反转存疑", count: 45 },
      { name: "热度见顶", count: 29 },
      { name: "退热观察", count: 51 },
    ],
  },
  {
    id: "field",
    label: "分区围观",
    desc: "按赛道对号入座",
    topics: [
      { name: "直播区", count: 74, tone: "primary" },
      { name: "带货区", count: 82 },
      { name: "综艺区", count: 58, tone: "accent" },
      { name: "短视频区", count: 90 },
      { name: "选秀区", count: 36 },
      { name: "探店区", count: 23 },
      { name: "知识区", count: 41 },
      { name: "音综区", count: 27 },
    ],
  },
  {
    id: "type",
    label: "翻车形态",
    desc: "按把柄类型归类",
    topics: [
      { name: "人设塌房", count: 121, tone: "primary" },
      { name: "言论翻车", count: 96 },
      { name: "带货翻车", count: 78, tone: "accent" },
      { name: "旧账被翻", count: 63 },
      { name: "互动失控", count: 41 },
      { name: "迟到爽约", count: 22 },
      { name: "合同纠纷", count: 34 },
      { name: "数据造假", count: 29 },
    ],
  },
  {
    id: "state",
    label: "当下状态",
    desc: "按处理进度归档",
    topics: [
      { name: "冷处理中", count: 47 },
      { name: "翻车进行时", count: 66, tone: "accent" },
      { name: "已发声明", count: 85, tone: "secondary" },
      { name: "二次塌房", count: 33, tone: "primary" },
      { name: "疑似洗白", count: 58 },
      { name: "彻底凉透", count: 27, tone: "primary" },
    ],
  },
];

export type RankStatus = "塌房" | "翻车" | "争议";

export interface RankItem {
  name: string;
  field: string;
  status: RankStatus;
  reason: string;
  heat: number;
  comments: string;
  delta: "up" | "down" | "new" | "flat";
}

export const rankList: RankItem[] = [
  {
    name: "阿澈Auror",
    field: "音综区",
    status: "塌房",
    reason: "人设与旧直播行为对不上，被逐条截图拼图",
    heat: 982,
    comments: "1.2万",
    delta: "new",
  },
  {
    name: "潮牌主理人Q",
    field: "带货区",
    status: "翻车",
    reason: "溯源声明被秒打脸，同款货比价差 3 倍",
    heat: 947,
    comments: "9800",
    delta: "up",
  },
  {
    name: "晓Tina",
    field: "短视频区",
    status: "争议",
    reason: "数据曲线诡异，涨粉时间与投放高度重合",
    heat: 873,
    comments: "7600",
    delta: "up",
  },
  {
    name: "大鹅说",
    field: "知识区",
    status: "翻车",
    reason: "被指出引用旧闻当新知，观点前后反复",
    heat: 812,
    comments: "6400",
    delta: "flat",
  },
  {
    name: "夜半讲坛",
    field: "直播区",
    status: "塌房",
    reason: "互撕录音流出，团队内讧搬到台面",
    heat: 765,
    comments: "5500",
    delta: "up",
  },
  {
    name: "Momo酱",
    field: "探店区",
    status: "争议",
    reason: "一条视频同场景两版文案，被质疑恰饭硬广",
    heat: 698,
    comments: "4300",
    delta: "down",
  },
  {
    name: "硬核老王",
    field: "测评区",
    status: "翻车",
    reason: "测评结论与后台真实数据对不上，疑似双标",
    heat: 631,
    comments: "3900",
    delta: "down",
  },
  {
    name: "Kiri-琪",
    field: "选秀区",
    status: "争议",
    reason: "复活名单存疑，票池被质疑有猫腻",
    heat: 584,
    comments: "3400",
    delta: "flat",
  },
];

export interface Persona {
  name: string;
  field: string;
  status: RankStatus;
  summary: string;
  tags: string[];
  points: string[];
}

export const personas: Persona[] = [
  {
    name: "阿澈Auror",
    field: "音综区",
    status: "塌房",
    summary: "舞台少年感与私下旧直播的落差被拆解成连续剧。",
    tags: ["旧账被翻", "人设塌房", "录音流出"],
    points: ["三年旧直播切片被重新考古", "团队声明前后口径不一致", "商务接洽出现撤单潮"],
  },
  {
    name: "潮牌主理人Q",
    field: "带货区",
    status: "翻车",
    summary: "自称一手货源，却被发现货不对板、比价悬殊。",
    tags: ["带货翻车", "溯源声明", "价格双标"],
    points: ["所谓工厂实拍被扒是摆拍", "同款渠道价差达 3 倍", "退货率环比飙升"],
  },
  {
    name: "晓Tina",
    field: "短视频区",
    status: "争议",
    summary: "一夜爆火的曲线太顺，被质疑数据由投放撑起。",
    tags: ["数据造假", "投放嫌疑", "涨粉异常"],
    points: ["涨粉时间与投放周期重合", "评论区画风高度同质", "官方暂无回应"],
  },
  {
    name: "大鹅说",
    field: "知识区",
    status: "翻车",
    summary: "把旧闻当新知讲，观点也先后打过自己的脸。",
    tags: ["言论翻车", "引用失实", "观点反复"],
    points: ["被粉丝逐条指出年代错位", "此前力挺的观点已反转", "视频已部分下架重剪"],
  },
  {
    name: "夜半讲坛",
    field: "直播区",
    status: "塌房",
    summary: "团队内讧录音外流，把幕后矛盾摆到了台面。",
    tags: ["录音流出", "团队内讧", "冷处理中"],
    points: ["录音内容涉及分账分歧", "曾合作主播集体沉默", "档期被临时取消"],
  },
  {
    name: "Momo酱",
    field: "探店区",
    status: "争议",
    summary: "同一场景两种文案，探店客观性被打了问号。",
    tags: ["恰饭硬广", "一鱼两吃", "已发声明"],
    points: ["同画面两版脚本被比对", "商家名单被粉丝整理", "声明被质疑避重就轻"],
  },
];

export interface TimelineEvent {
  date: string;
  tag: string;
  title: string;
  desc: string;
  tone: Tone;
}

export const timeline: TimelineEvent[] = [
  {
    date: "09.06",
    tag: "新晋塌房",
    title: "阿澈Auror 三年前直播切片集中引爆",
    desc: "考古帖登顶热榜，相关商务陆续传出撤单。",
    tone: "primary",
  },
  {
    date: "09.05",
    tag: "声明反转",
    title: "潮牌主理人Q 溯源声明被现场打脸",
    desc: "声明里晒的工厂，被网友反手定位成共享展厅。",
    tone: "accent",
  },
  {
    date: "09.04",
    tag: "舆论发酵",
    title: "晓Tina 涨粉曲线遭遇集中扒皮",
    desc: "数据工具被逐条引用，争议从评论区蔓延到视频。",
    tone: "secondary",
  },
  {
    date: "09.03",
    tag: "榜单换血",
    title: "「翻车名单」周榜重排，三位新人上榜",
    desc: "本周口径调整后，状态标记更细分为塌房与翻车。",
    tone: "secondary",
  },
  {
    date: "09.02",
    tag: "旧账重提",
    title: "大鹅说 两年前观点与当下言行被同框",
    desc: "「昔日打脸现场」合集播放量快速攀升。",
    tone: "accent",
  },
  {
    date: "09.01",
    tag: "本月复盘",
    title: "上月争议名单完成复核归档",
    desc: "12 条线索经双信源比对后，6 条完成入档。",
    tone: "secondary",
  },
];

export interface HotComment {
  name: string;
  meta: string;
  text: string;
  likes: string;
  hot: boolean;
  tone: Tone;
}

export const hotComments: HotComment[] = [
  {
    name: "瓜田守夜人",
    meta: "考古系 · 前排蹲",
    text: "旧切片一翻一个准，建议再挖深一档，感觉还没到底。",
    likes: "3.4万",
    hot: true,
    tone: "accent",
  },
  {
    name: "不站队的K",
    meta: "理性派 · 只看证据",
    text: "声明和切片都对不上，先别急着骂，等第二波回应吧。",
    likes: "2.1万",
    hot: false,
    tone: "secondary",
  },
  {
    name: "前排磕瓜子",
    meta: "吃瓜路人 · 坐等后续",
    text: "评论区比正片精彩，预感这单要蹲一个连续剧。",
    likes: "1.6万",
    hot: false,
    tone: "primary",
  },
  {
    name: "证据控小王",
    meta: "复核组 · 轻度较真",
    text: "把同款渠道价比一圈再说话，这波翻车不冤。",
    likes: "9800",
    hot: false,
    tone: "secondary",
  },
];